export default class MouseStateMachine {
	constructor(state, capture) {
		this.element = null;
		this.options = { 
			capture : capture !== undefined ? capture :false,
			passive : true,
		};
		this.options_move = {
			capture : capture !== undefined ? capture :false,
			passive : false,
		};
		this.state = state;
		this.downed = 0;
		this.uped = 0;
		this.longpressed = false;
		this.listener = {
			touchstart: null,
			touchmove: null,
			touchend: null,
			mousedown: null,
			mousemove: null,
			mouseup: null,
			click: null,
			longpress: null,
		};
	}
	
	removeEventListener() {
		this.element.removeEventListener('touchstart', this.listener.touchstart, this.options);
		this.element.removeEventListener('touchmove', this.listener.touchmove, this.options);
		this.element.removeEventListener('touchend', this.listener.touchend, this.options);
		this.element.removeEventListener('mousedown', this.listener.mousedown, this.options);
		this.element.removeEventListener('mousemove', this.listener.mousemove, this.options);
		this.element.removeEventListener('mouseup', this.listener.mouseup, this.options);
		this.element.removeEventListener('click', this.listener.click, this.options);
		this.element.removeEventListener('longpress', this.listener.longpress, this.options);

		this.listener.touchstart = null;
		this.listener.touchmove = null;
		this.listener.touchup = null;
		this.listener.mousedown = null;
		this.listener.mousemove = null;
		this.listener.mouseup = null;
		this.listener.click = null;
		this.listener.longpress = null;
	}
	
	addEventListener() {
		const EVENT = {
			MOUSE: 1,
			TOUCH: 2,
		};
		const NEXT = (state) => {
			this.next(state);
		};
		/* down */
		this.listener.touchstart = (e) => {
			this.downed = EVENT.TOUCH;
			if (this.state && this.state.down)
				this.state.down(e, NEXT);
			this.longpressed = false; // clickが発生しない場合がある為
		};
		this.listener.mousedown = (e) => {
			this.downed |= EVENT.MOUSE;
			if (this.downed & EVENT.TOUCH)
				return;
			if (this.state && this.state.down)
				this.state.down(e, NEXT);
			this.longpressed = false; // clickが発生しない場合がある為
		};

		/* move */
		this.listener.touchmove = (e) => {
			if (this.state && this.state.move)
				this.state.move(e, NEXT);
		};
		this.listener.mousemove = (e) => {
			if (this.state && this.state.move)
				this.state.move(e, NEXT);
		};

		/* up */
		this.listener.touchend = (e) => {
			this.uped = EVENT.TOUCH;
			if (this.state && this.state.up)
				this.state.up(e, NEXT);
		}
		this.listener.mouseup = (e) => {
			this.uped |= EVENT.MOUSE;
			if (this.uped & EVENT.TOUCH)
				return;
			if (this.state && this.state.up)
				this.state.up(e, NEXT);
		}

		/* click */
		this.listener.click = (e) => {
			if (this.longpressed) {
				if (this.state && this.state.longclick) {
					this.state.longclick(e, NEXT);
				}
			} else {
				if (this.state && this.state.click) {
					this.state.click(e, NEXT);
				}
			}
		}

		/* longpress */
		this.listener.longpress = (e) => {
			this.longpressed = true;
			if (this.state && this.state.longpress){
				this.state.longpress(e, NEXT);
			}
		}

		
		this.element.addEventListener('touchstart', this.listener.touchstart, this.options);
		this.element.addEventListener('touchmove', this.listener.touchmove, this.options_move);
		this.element.addEventListener('touchend', this.listener.touchend, this.options);
		this.element.addEventListener('touchcancel', this.listener.touchend, this.options);
		this.element.addEventListener('mousedown', this.listener.mousedown, this.options);
		this.element.addEventListener('mousemove', this.listener.mousemove, this.options_move);
		this.element.addEventListener('mouseup', this.listener.mouseup, this.options);
		this.element.addEventListener('click', this.listener.click, this.options);
		this.element.addEventListener('long-press-start', this.listener.longpress, this.options);
	}
	
	next(state) {
		this.state = state;
	}
	
	bind(element) {
		this.element = element;
		this.addEventListener();
	}
	
	unbind() {
		this.removeEventListener();
		this.element = null;
		
	}
}
